import { HttpContextToken } from "@angular/common/http";

import {
    CombinedFacets,
    CurrentRouteData,
    Facet,
} from "../store/grid.store.model";

export const MISSING_FACET_CONTEXT =
    new HttpContextToken<MissingFacetContext | null>(() => null);

export interface MissingFacetContext {
    currentRouteData: CurrentRouteData;
    facet: Facet;
    result?: MissingFacetResult;
}

export interface MissingFacetResult {
    isMissingFacet: boolean;
    filteredValues: CombinedFacets[];
}
